// Separate from display ads. Visibility does not configure an ad provider.
export function areRewardedAdsEnabled() {
  return String(process.env.REACT_APP_REWARDED_ADS_ENABLED || '').trim().toLowerCase() === 'true';
}
